export const ADMIN = "ADMIN";
export const OBSERVER = "OBSERVER";
export const USER = "USER";

export const ADMIN_OBSERVER = ADMIN + OBSERVER;
export const OBSERVER_USER = OBSERVER + USER;
export const ADMIN_OBSERVER_USER = ADMIN + OBSERVER + USER;